import React, { useEffect, useState } from 'react';
import { Typography, TextField, FormGroup, FormControl, FormLabel } from '@mui/material';
import { useUpdateDealRowMutation } from '@/features/deals/dealsApi';
import { ADDITIONAL_SPECIALIST_PRODUCTS } from '@/components/forms/CreateNewBusinessForm/validationSchema';
import { useParams } from 'react-router-dom';
import { useObjectContext } from '@/hooks/useObjectContext';

export const AdditionalProducts = () => {
	const { dealId } = useParams();
	const { dealRow } = useObjectContext();

	const [additionalValue, setAdditionalValue] = useState(
		dealRow?.additionalSpecialistProducts ?? '',
	);

	useEffect(() => {
		setAdditionalValue(dealRow?.additionalSpecialistProducts ?? '');
	}, [dealRow?.additionalSpecialistProducts]);

	const [updateDeal, { isLoading }] = useUpdateDealRowMutation();

	const onChange = async () => {
		await updateDeal({
			dealId,
			docId: dealRow?.id,
			properties: {
				[ADDITIONAL_SPECIALIST_PRODUCTS]: additionalValue,
			},
		}).unwrap();
	};

	return (
		<FormControl fullWidth>
			<FormLabel>
				Additional specialist insurance products discussed and the outcomes
			</FormLabel>
			<TextField
				fullWidth
				disabled={isLoading}
				multiline
				rows={4}
				value={additionalValue}
				onChange={(e) => setAdditionalValue(e.target.value)}
				onBlur={onChange}
			/>
		</FormControl>
	);
};
